<template>
  <div>
    <PageHeader :gradientType="gradientType"/>
    <PageContent>
      <template #filterBar>
        <form @submit.prevent="setFilter">
          <h6 class="heading-small text-muted mb-4">Search</h6>
          <div class="row">
            <div class="col">
              <a-input placeholder="Search by" v-model="table.filters.title">
                <a-select
                    slot="addonAfter"
                    default-value="title"
                    style="width: 80px"
                >
                  <a-select-option value="title">
                    Title
                  </a-select-option>
                </a-select>
              </a-input>
            </div>
          </div>
          <hr/>
          <h6 class="heading-small text-muted mb-4">Filter by Status</h6>
          <div class="row">
            <div class="col">
              <a-radio-group
                  v-model="table.filters.status_code"
                  :default-value="null"
                  @change="setFilter"
              >
                <a-radio :style="radio.style" :value="null">
                  All
                </a-radio>
                <a-radio :style="radio.style" value="A">
                  Active
                </a-radio>
                <a-radio :style="radio.style" value="I">
                  Inactive
                </a-radio>
              </a-radio-group>
            </div>
          </div>
        </form>
      </template>

      <template #pageTable>
        <PageTable
            :tableTitle="table.title"
            :apiUrl="table.apiUrl"
            :tableFields="table.fields"
            :appendedParams="table.filters"
            :sortOrder="table.sortOrder"
        >
          <template #headerButtons>
            <base-button
                id="new"
                class="float-right ml-1"
                type="primary"
                size="sm"
                v-if="selectedActions.includes('Add')"
                @click="openDrawer()"
            >+ Add Sales Invoice Text
            </base-button
            >
          </template>

          <template #formDrawer>
            <a-drawer
                :width="drawer.width"
                :placement="drawer.placement"
                :visible="drawer.visible"
                @close="closeDrawer"
            >
              <MessageForm
                  :viewMode="viewMode"
                  :messageData="messageData"
                  :drawerVisible="drawer.visible"
                  @closeDrawer="closeDrawer"
              />
            </a-drawer>
          </template>

          <template #tableButtons="{tableProps}">
            <div class="d-flex justify-content-around">
              <button
                  id="view"
                  class="btn btn-success btn-sm w-100"
                  v-if="selectedActions.includes('View')"
                  @click.prevent="openDrawer(tableProps.rowData)"
              >
                View
              </button>
              <button
                  id="edit"
                  class="btn btn-warning btn-sm w-100"
                  v-if="selectedActions.includes('Edit')"
                  @click.prevent="openDrawer(tableProps.rowData)"
              >
                Edit
              </button>
              <a-popconfirm
                  title="You are about to delete this record?"
                  v-if="selectedActions.includes('Delete')  && tableProps.rowData.memberStatus && tableProps.rowData.memberStatus.length == 0"
                  @confirm="deleteRow(tableProps.rowData)"
                  okText="Delete"
                  cancelText="Cancel"
              >
                <a class="btn btn-danger btn-sm text-white w-100">Delete</a>
              </a-popconfirm>
            </div>
          </template>
        </PageTable>
      </template>
    </PageContent>
  </div>
</template>

<script>
import PageHeader from '../../components/Page/Header.vue';
import PageContent from '../../components/Page/Content.vue';
import PageTable from '../../components/Page/Table.vue';
import MessageForm from './MessageForm.vue';
import HTTPRequest from '../../controllers/httpRequest';
import {mapGetters} from 'vuex';

export default {
  components: {
    PageHeader,
    PageContent,
    PageTable,
    MessageForm
  },
  data() {
    return {
      // selectedActions: [],
      gradientType: 'gradient-orange',
      messageData: null,
      drawer: {
        visible: false,
        width: 600,
        placement: 'right'
      },
      viewMode: false,
      table: {
        title: 'Sales Invoice Texts',
        apiUrl: '/api/v1/clp_messages',
        fields: [
          'actions',
          {name: 'membershipProgram.name', title: 'Membership Program'},
          'title',
          'message'
        ],
        sortOrder: [
          {
            field: 'id',
            direction: 'desc'
          }
        ],
        filters: {
          status_code: null,
          title: null
        }
      },

      radio: {
        style: {
          display: 'block',
          height: '35px',
          lineHeight: '30px'
        }
      }
    };
  },
  computed: {
    ...mapGetters({
      selectedActions: 'getModuleSelectedActions'
    })
  },
  methods: {
    openDrawer(rowData = null) {
      this.viewMode = event.target.id == 'view' ? true : false;
      this.messageData = rowData;
      this.drawer.visible = true;
    },

    closeDrawer() {
      this.drawer.visible = false;
      this.messageData = null;
    },

    setFilter() {
      this.$root.$emit('refreshTable');
    },

    async deleteRow(rowData) {
      const messageId = rowData.id;

      const response = await HTTPRequest.deleteRequest(
          `/api/v1/clp_messages/${messageId}`,
          {
            message: {
              membership_program_id: rowData.membership_program_id
            }
          }
      );

      if (response.message == 'Success') {
        this.$notification.success({
          message: 'Success'
        });
        this.$root.$emit('refreshTable');
      } else {
        if (response.error != undefined) {
          this.$notification.error({
            message: response.error
          });
        } else {
          this.$notification.error({
            message: 'Something went wrong. Please try again.'
          });
        }
      }
    }
  },

  created() {
    this.$store.dispatch('setCurrentModule', 'Messages');
  },
  mounted() {
    this.selectedActions = this.$store.getters.getModuleSelectedActions;
  }
};
</script>

<style scoped></style>
